const removeSpaces = (str, replacement) => str.replace(/\s/g, replacement)

export default removeSpaces;
